import type { MapperOptions } from '~/types'
import { mapperModuleMedia } from '../../modules/mappers'

/**
 * Global data payment method type mapper
 * @param {Object} data - cms response data
 * @param {Object} options - mapper options
 * @return {Object} the normalized data
 */
export const mapperGlobalDataPersona = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  return {
    id: data.sys?.id || '',
    name: data.name || '',
    role: data.role || '',
    shortDescription: data.shortDescription || '',
    description: data.longDescription || '',
    image: mapperModuleMedia(data.image, options.imageOptions),
    memberSince: data.memberSince || '-',
    currentTerm: data.currentTerm || '-'
  }
}
